import React from "react";

/**
 * Proximity brand logo. Uses the shield PNG from /public.
 *
 * Sizes are cosmetic; the underlying asset is a high-resolution PNG so this
 * scales cleanly from favicon-size up to hero-header.
 */
export default function Logo({ size = 40, className = "", withWordmark = false }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/proximity-logo.png"
        alt="Proximity"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        draggable={false}
      />
      {withWordmark && (
        <span className="font-display font-black tracking-tighter" style={{ fontSize: Math.round(size * 0.55) }}>
          PROXIMITY
        </span>
      )}
    </span>
  );
}
